import { Directive, forwardRef, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";

@Directive({
    selector: '[min]',
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => MinValidatorDirective), multi: true }],
    standalone: false
})
export class MinValidatorDirective implements Validator {
    @Input() min: number;

    validate(control: AbstractControl): {[key: string]: any} | null {
        return control.value < this.min ? {'min': true} : null;
    }
}
